import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class LandingPagesApi extends Api {
  constructor() {
    super('website/landing_pages/');
  }

  // GET all with filters
  list = (params = {}) => {
    return this.buildQuery('get', { params });
  };

  // GET one by ID
  show = (id) => {
    return this.buildQuery('get', {}, id);
  };

  // CREATE landing page
  create = (data) => {
    const formData = new FormData();

    // Title fields (multilingual)
    if (data.title_it) formData.append('landing_page[title_it]', data.title_it);
    if (data.title_en) formData.append('landing_page[title_en]', data.title_en);
    if (data.title_fr) formData.append('landing_page[title_fr]', data.title_fr);

    // Link fields (multilingual)
    if (data.link_it) formData.append('landing_page[link_it]', data.link_it);
    if (data.link_en) formData.append('landing_page[link_en]', data.link_en);
    if (data.link_fr) formData.append('landing_page[link_fr]', data.link_fr);

    // Meta Title fields (multilingual)
    if (data.meta_title_it) formData.append('landing_page[meta_title_it]', data.meta_title_it);
    if (data.meta_title_en) formData.append('landing_page[meta_title_en]', data.meta_title_en);
    if (data.meta_title_fr) formData.append('landing_page[meta_title_fr]', data.meta_title_fr);

    // Meta Description fields (multilingual)
    if (data.meta_description_it) formData.append('landing_page[meta_description_it]', data.meta_description_it);
    if (data.meta_description_en) formData.append('landing_page[meta_description_en]', data.meta_description_en);
    if (data.meta_description_fr) formData.append('landing_page[meta_description_fr]', data.meta_description_fr);

    // Meta URL fields (multilingual)
    if (data.meta_url_it) formData.append('landing_page[meta_url_it]', data.meta_url_it);
    if (data.meta_url_en) formData.append('landing_page[meta_url_en]', data.meta_url_en);
    if (data.meta_url_fr) formData.append('landing_page[meta_url_fr]', data.meta_url_fr);

    // Shopping center
    if (data.shopping_center_id) {
      formData.append('landing_page[shopping_center_id]', data.shopping_center_id);
    }

    // Content (hash with html for each language)
    if (data.content) {
      Object.keys(data.content).forEach((lang) => {
        const langContent = data.content[lang];
        if (langContent.html !== undefined) {
          formData.append(`landing_page[content][${lang}][html]`, langContent.html || '');
        }
      });
    }

    // Page structure (JSON for each language)
    if (data.page_structure) {
      Object.keys(data.page_structure).forEach((lang) => {
        formData.append(`landing_page[page_structure][${lang}]`, JSON.stringify(data.page_structure[lang]));
      });
    }

    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/landing_pages`,
      method: 'POST',
      data: formData,
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // UPDATE landing page
  update = (id, data) => {
    const formData = new FormData();

    // Title fields (multilingual)
    if (data.title_it) formData.append('landing_page[title_it]', data.title_it);
    if (data.title_en) formData.append('landing_page[title_en]', data.title_en);
    if (data.title_fr) formData.append('landing_page[title_fr]', data.title_fr);

    // Link fields (multilingual)
    if (data.link_it) formData.append('landing_page[link_it]', data.link_it);
    if (data.link_en) formData.append('landing_page[link_en]', data.link_en);
    if (data.link_fr) formData.append('landing_page[link_fr]', data.link_fr);

    // Meta Title fields (multilingual)
    if (data.meta_title_it) formData.append('landing_page[meta_title_it]', data.meta_title_it);
    if (data.meta_title_en) formData.append('landing_page[meta_title_en]', data.meta_title_en);
    if (data.meta_title_fr) formData.append('landing_page[meta_title_fr]', data.meta_title_fr);

    // Meta Description fields (multilingual)
    if (data.meta_description_it) formData.append('landing_page[meta_description_it]', data.meta_description_it);
    if (data.meta_description_en) formData.append('landing_page[meta_description_en]', data.meta_description_en);
    if (data.meta_description_fr) formData.append('landing_page[meta_description_fr]', data.meta_description_fr);

    // Meta URL fields (multilingual)
    if (data.meta_url_it) formData.append('landing_page[meta_url_it]', data.meta_url_it);
    if (data.meta_url_en) formData.append('landing_page[meta_url_en]', data.meta_url_en);
    if (data.meta_url_fr) formData.append('landing_page[meta_url_fr]', data.meta_url_fr);

    // Shopping center
    if (data.shopping_center_id) {
      formData.append('landing_page[shopping_center_id]', data.shopping_center_id);
    }

    // Content (hash with html for each language)
    if (data.content) {
      Object.keys(data.content).forEach((lang) => {
        const langContent = data.content[lang];
        if (langContent.html !== undefined) {
          formData.append(`landing_page[content][${lang}][html]`, langContent.html || '');
        }
      });
    }

    // Page structure (JSON for each language)
    if (data.page_structure) {
      Object.keys(data.page_structure).forEach((lang) => {
        formData.append(`landing_page[page_structure][${lang}]`, JSON.stringify(data.page_structure[lang]));
      });
    }

    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/landing_pages/${id}`,
      method: 'PUT',
      data: formData,
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // DELETE landing page
  destroy = (id) => {
    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/landing_pages/${id}`,
      method: 'DELETE',
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // UPLOAD asset (images, files) for landing pages
  upload = (file) => {
    const formData = new FormData();
    formData.append('file', file);

    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/landing_pages/uploads`,
      method: 'POST',
      data: formData,
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // GET filters (shopping_centers)
  getFilters = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/filters`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default new LandingPagesApi();


